var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 404: Page not found ")])
}
var staticRenderFns = []

export { render, staticRenderFns }